module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/372.e13a8bd6.png";